import React from 'react'
import styled from 'styled-components'
import { FiChevronRight } from 'react-icons/fi'
import { device } from './Breakpoints'
import { colors } from './Colors'

const Container = styled.section`
  color: white;
  background: ${colors.laranjaGradienteReverso};
  box-sizing: border-box;
  margin: 0em 0 1em;
  padding: 2em 1em;
  width: 100%;
  h2 {
    width: 100%;
    display: block;
  }
  a {
    width: 100%;
    max-width: 182px;
    height: 50px;
    text-align: center;
    flex-grow: 0;
    background-color: #ffffff;
    padding: 1em 2em;
    border-radius: 50px;
    text-transform: uppercase;
    font-size: 0.8em;
    text-decoration: none;
    color: #ff8f8c;
    opacity: 1;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    :hover {
      opacity: 0.8;
    }
    svg {
      color: #793939;
    }
    @media ${device.mobileL} {
      margin: auto;
    }
  }
  ul {
    padding: 0;
    margin: 0;
    li {
      margin: 0 0 1.5em 0;
      padding: 0;
      list-style: none;
      background: #ffffff;
      box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
      :last-child {
        margin: 0;
      }
      .ExamesHeader {
        background: #793939;
        padding: 0.5em 2em;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media ${device.mobileL} {
          flex-wrap: wrap;
          padding: 2em;
        }
        h3 {
          font-size: 0.9em;
          position: relative;
          padding: 0.6 em 0;
          font-weight: normal;
          margin-top: 1em;
          @media ${device.mobileL} {
            margin-bottom: 2.5em;
            text-align: center;
          }
          :before {
            position: absolute;
            content: '';
            top: -10px;
            left: 0;
            border: 1px solid #a57777;
            width: 10%;
            @media ${device.mobileL} {
              left: 45%;
            }
          }
          :after {
            position: absolute;
            content: '';
            bottom: -10px;
            left: 0;
            border: 1px solid #a57777;
            width: 10%;
            @media ${device.mobileL} {
              left: 45%;
            }
          }
        }
      }
      .ExamesDescription {
        padding: 1em 3em;
        p {
          color: ${colors.cinza};
          font-size: 0.9em;
        }
      }
    }
  }
`

const ExamesList = ({ title, links }) => {
  return (
    <Container>
      <div className="center">
        <h2>{title}</h2>
        <ul>
          {links.map(link => (
            <li key={link.tituloLink}>
              <div className="ExamesHeader">
                <h3>{link.tituloLink}</h3>
                <a
                  href={link.url}
                  title={link.tituloLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Acesse aqui
                  <FiChevronRight />
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </Container>
  )
}

export default ExamesList
